import { observer } from 'mobx-react-lite'
import { PlanIncludesTooltip } from 'pages/settings/ui/BillingPlan/ui/PlanIncludesTooltipContent/PlanIncludesTooltipContent'

type NumberPlanIncludesTooltipProps = {
  additionalNumberPrice: string
}

export const NumberPlanIncludesTooltip = observer(
  ({ additionalNumberPrice }: NumberPlanIncludesTooltipProps) => {
    return (
      <PlanIncludesTooltip
        items={[
          { label: '1st number:', value: 'FREE' },
          { label: 'Additional numbers:', value: additionalNumberPrice },
        ]}
      />
    )
  }
)
